
import { requireAuth } from './auth';

const paymentURL = process.env.VUE_APP_API_PAYMENT_URL;

export async function postCreditPay(priceId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const form = new URLSearchParams();
    form.append('price_id', priceId);
    const url = `${paymentURL}/payment/credit_pay`;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}`,
        },
        body: form.toString()
    });
    return response;
}

export async function postSubPay(priceId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const form = new URLSearchParams();
    form.append('price_id', priceId);
    const url = `${paymentURL}/payment/sub_pay`;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}`,
        },
        body: form.toString()
    });
    return response;
}

export async function postSubCancel() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const form = new URLSearchParams();
    const url = `${paymentURL}/payment/cancel`;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}`,
        },
        body: form.toString()
    });
    return response;
}

export async function ensureWelcomeCredit() {
    if (!await requireAuth('set up welcome credits')) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${paymentURL}/credit/initial`;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    if (!response.ok) {
        const message = await response.text();
        throw new Error(`Welcome credit setup failed: HTTP ${response.status} ${message}`);
    }
    return await response.json();
}

export async function getCreditTransactions() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${paymentURL}/frontend_query/GetCreditTransactions`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}


export async function getCreditBalance() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${paymentURL}/frontend_query/GetCreditBalance`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        }
    });
    if (!response.ok) {
        throw new Error(`HTTP ${response.status} ${response.statusText}`);
    }
    const payload = await response.json();
    return payload.current_balance;
}

export async function getUserSubProduct() {
    console.log('getUserSubProduct() in API')
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${paymentURL}/frontend_query/GetUserSubProduct`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    console.log(response)
    const data = await response.json();
    return data;
}

export async function getPaymentHistory() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = `${paymentURL}/frontend_query/GetPaymentHistory`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function postTenderOffer(tender) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token');
    const url = `${paymentURL}/c360/tender-offer`;
    const body = JSON.stringify({
        tender
    });
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        body
    });
    if (!res.ok) {
        throw new Error(`HTTP ${res.status} ${res.statusText}`);
    }
    const payload = await res.json();
    return payload;
}
